import { create } from 'zustand'

const storageKey = 'lotto-cashier-mode'

type CashierModeState = {
  flag: boolean
  setCashierMode: (value: boolean) => void
}

export const useCashierModeStore = create<CashierModeState>((set) => ({
  flag: !!window.localStorage.getItem(storageKey),
  setCashierMode: (value) => {
    set({ flag: value })
    if (value) {
      window.localStorage.setItem(storageKey, 'x')
    } else {
      window.localStorage.removeItem(storageKey)
    }
  },
}))
export function useCashierMode(): [boolean, (v: boolean) => void] {
  const flag = useCashierModeStore((s) => s.flag)
  const set = useCashierModeStore((s) => s.setCashierMode)
  return [flag, set]
}
